<div class="account-font-edit-dialog-component">
  <div class="brand-settings">
    <div class="headline-title">{{ "settings.customization.copy-brand-settings.title" | translate }}</div>
    <div class="dialog-row dialog-content">
      <!-- Removed until we have more types of settings to copy<h3>{{ "settings.customization.brand-title" | translate }}</h3>-->
      <mat-slide-toggle [(ngModel)]="shouldCopyDesign" class="toggle-item">
        <span class="toggle-text">{{ "settings.customization.copy-brand-settings.toggle-design" | translate }}</span>
      </mat-slide-toggle>
      <div class="text-variables-wrapper">
        <mat-slide-toggle [(ngModel)]="shouldCopyText" class="toggle-item">
          <span class="toggle-text">{{ "settings.customization.copy-brand-settings.toggle-text" | translate }}</span>
        </mat-slide-toggle>

        <mat-checkbox [(ngModel)]="shouldReplaceTextVariables" class="replace-text-check-box">
          {{ "settings.customization.copy-brand-settings.should-replace-text-variables" | translate }}
        </mat-checkbox>
      </div>
    </div>
    <div class="dialog-row dialog-content brand-settings-from-account">
      <h3>
        {{ "settings.customization.copy-brand-settings.from-account" | translate }}:
        <span>{{ currentAccountName }}</span>
      </h3>
    </div>
    <div class="dialog-row dialog-content">
      <mat-form-field class="list-dropdown" appearance="outline">
        <mat-label>{{ "settings.customization.copy-brand-settings.to-accounts" | translate }}</mat-label>
        <mat-select [formControl]="siteIdsControl" multiple>
          <mat-select-trigger>
            {{ selectedAccountsString }}
            @if ((siteIdsControl.value?.length || 0) > 3) {
              <span class="example-additional-selection">
                (+{{ (siteIdsControl.value?.length || 0) - 3 }} {{ siteIdsControl.value?.length === 4 ? "other" : "others" }}
                )
              </span>
            }
          </mat-select-trigger>
          <div class="select-all">
            @if (allCurrentSitedIds.length > 1) {
              <mat-checkbox [(ngModel)]="selectAll" (change)="toggleSelectAll()">Select All</mat-checkbox>
            }
          </div>
          @for (account of currentAccounts; track account) {
            <mat-option [value]="account.siteId">{{ account.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (isAdmin) {
      <mat-checkbox [(ngModel)]="showAllAccounts" (change)="onShowAllAccounts()" class="show-all-accounts">
        <span class="admin-only-round">A</span>
        {{ "settings.customization.copy-brand-settings.show-all-accounts" | translate }}
      </mat-checkbox>
    }
  </div>
  <div class="button-row">
    <!-- Close BUTTON -->
    <button mat-stroked-button class="secondary-button close-button" (click)="closeDialog()">
      {{ "generic.close" | translate }}
    </button>
    <!-- COPY BUTTON -->
    <button
      mat-stroked-button
      [disabled]="isLoading || !((this.shouldCopyDesign || this.shouldCopyText) && this.siteIdsControl.value.length > 0)"
      class="primary-button copy-button"
      (click)="copyBrandSettings()">
      @if (isLoading) {
        <mat-spinner class="spinner" [diameter]="18" [mode]="'indeterminate'" [class.inProgress]="isLoading"></mat-spinner>
      }
      {{ "generic.copy" | translate }}
    </button>
  </div>
</div>
